import { useTranslation } from 'react-i18next'
import { Button } from '@/components/shadcn/button'

interface Props {
  onClick: () => void
}

export function AddFeatureFlagButton({ onClick }: Props) {
  const { t } = useTranslation('super-admin-feature-flags')
  return (
    <Button onClick={onClick}>
      {t('actions.add')}
    </Button>
  )
}
